export default __webpack_public_path__ + "assets/png/5a3c1b2e6b855e02d2d9f6cbfdd88f45.png";